import { useMemo } from "react";
import { FILTERS } from "../../constants";
import { useSelector } from "react-redux";
import { getFilters } from "../../store/search/selectors";

export function useAppliedFilters() {
  const filters = useSelector(getFilters);

  return useMemo(() => {
    const filterNames: Array<string> = [];
    if (filters.duration || filters.maxLayoverDuration) {
      filterNames.push(FILTERS.duration);
    }
    if (filters.airlines && filters.airlines.length > 0) {
      filterNames.push(FILTERS.airlines);
    }
    if (typeof filters.stops === "number" && filters.stops >= 0) {
      filterNames.push(FILTERS.stops);
    }
    if (filters.departureIntervals.length > 0 || filters.arrivalIntervals.length > 0) {
      filterNames.push(FILTERS.journeyTime);
    }
    if (filters.flightTimes) {
      const hasAtLeastOneSelectedFlightTimes = filters.flightTimes.some((flightTimes) => {
        const arrivals = flightTimes.arrival.some((flight) => flight.selected);
        const departures = flightTimes.departure.some((flight) => flight.selected);
        return arrivals || departures;
      });
      hasAtLeastOneSelectedFlightTimes && filterNames.push(FILTERS.flightTimes);
    }
    if (!!filters.shortLayoverConnection) {
      filterNames.push(FILTERS.shortLayoverConnection);
    }
    if (filters.maxBudget !== undefined) {
      filterNames.push(FILTERS.budget);
    }
    if (filters.maxBudgetPerAdult !== undefined) {
      filterNames.push(FILTERS.budgetPerAdult);
    }
    if (!!filters.includedBaggage?.length) {
      filterNames.push(FILTERS.includedBaggage);
    }
    if (!!filters.airports?.length) {
      filterNames.push(FILTERS.airports);
    }
    if (!!filters.preferSameAirport) {
      filterNames.push(FILTERS.preferSameAirport);
    }
    if (filters.allDeals) {
      filterNames.push(FILTERS.allDeals);
    }
    if (filters.flexibility?.length) {
      filterNames.push(FILTERS.flexibility);
    }
    return filterNames;
  }, [filters]);
}
